import type { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { queryClient, storage, updateTokens } from '@frontend/shared';
import { useMutation } from '@tanstack/react-query';

import { clearExtranetCache } from '../../../lib/session';
import type { ExtranetLoginInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

/**
 * `POST /v1/auth/login` — l'Extranet API proxifie allocab-auth et renvoie un
 * token `type: 'Extranet'` (session d'une heure, rafraîchie via passenger-api,
 * cf. `extranetApi.ts`). Mauvais identifiants → 403 `INVALID_CREDENTIALS`.
 */
const login = (input: ExtranetLoginInput) =>
  getExtranetApi().post<ExtranetLoginInput, LoginOutput>('/v1/auth/login', input, { skipAuth: true });

export const useExtranetLogin = () =>
  useMutation({
    mutationFn: login,
    onSuccess: tokens => {
      // Une session précédente (autre compte) a pu laisser `/v1/users/me` en cache.
      clearExtranetCache();
      storage.setJSONItem('tokens', tokens);
      updateTokens(queryClient, tokens);
    },
  });
